(function () {
Array.prototype.slice.call(document.querySelectorAll('.dcc-quote')).forEach(function (root) {

  var form = root.querySelector('.dcc-form');
  if (!form) return; /* thank-you state: no form present */

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-dcc-step]'));
  var progressSteps = Array.prototype.slice.call(root.querySelectorAll('[data-dcc-progress] .dcc-progress__step'));
  var current = 1;
  var total = steps.length;

  var cloudName = root.getAttribute('data-dcc-cloud-name') || '';
  var uploadPreset = root.getAttribute('data-dcc-upload-preset') || '';
  var maxPhotos = parseInt(root.getAttribute('data-dcc-max-photos'), 10) || 8;
  var uploadNote = root.querySelector('[data-dcc-upload-note]');
  if (!cloudName || !uploadPreset) { if (uploadNote) uploadNote.hidden = false; }

  /* ---------------- Navigation ---------------- */
  function showStep(n) {
    steps.forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.getAttribute('data-dcc-step'), 10) === n);
    });
    progressSteps.forEach(function (el) {
      var s = parseInt(el.getAttribute('data-step'), 10);
      el.classList.toggle('is-active', s === n);
      el.classList.toggle('is-complete', s < n);
    });
    current = n;
    if (n === total) buildSummary();
    var stepEl = root.querySelector('[data-dcc-step="' + n + '"]');
    if (stepEl) stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function validateStep(n) {
    if (n === 1) {
      var brand = root.querySelector('[data-dcc-brand]');
      var brandOtherWrap = root.querySelector('[data-dcc-brand-other]');
      var brandOther = root.querySelector('#dcc-brand-other');
      var model = root.querySelector('#dcc-model');
      var condition = root.querySelector('[data-dcc-condition] input:checked');
      if (!brand.value) { brand.focus(); return false; }
      if (brand.value === 'Andere' && brandOther && !brandOther.value.trim()) { brandOther.focus(); return false; }
      if (!model.value.trim()) { model.focus(); return false; }
      if (!condition) { root.querySelector('[data-dcc-condition]').scrollIntoView({ behavior: 'smooth', block: 'center' }); return false; }
      return true;
    }
    if (n === 2) {
      var checked = root.querySelectorAll('[data-dcc-treatments] input:checked');
      var err = root.querySelector('[data-dcc-error="treatments"]');
      if (checked.length === 0) { if (err) err.hidden = false; return false; }
      if (err) err.hidden = true;
      return true;
    }
    if (n === 4) {
      var name = root.querySelector('#dcc-name');
      var email = root.querySelector('#dcc-email');
      var phone = root.querySelector('#dcc-phone');
      var consent = root.querySelector('#dcc-consent');
      var contactErr = root.querySelector('[data-dcc-error="contact"]');

      function showContactError(msg, el) {
        if (contactErr) {
          contactErr.textContent = msg;
          contactErr.hidden = false;
          contactErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (el) el.focus();
      }

      if (!name.value.trim()) { showContactError('Vul je voornaam en achternaam in.', name); return false; }
      if (!email.value.trim() || !email.checkValidity()) { showContactError('Vul een geldig e-mailadres in.', email); return false; }
      if (!phone.value.trim()) { showContactError('Vul je telefoonnummer in.', phone); return false; }
      if (!consent.checked) { showContactError('Vink het vakje aan dat je akkoord gaat, zodat we je aanvraag mogen verwerken.', consent); return false; }

      if (contactErr) contactErr.hidden = true;
      return true;
    }
    return true;
  }

  root.querySelectorAll('[data-dcc-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!validateStep(current)) return;
      if (current < total) showStep(current + 1);
    });
  });
  root.querySelectorAll('[data-dcc-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (current > 1) showStep(current - 1);
    });
  });

  /* ---------------- Step 1: brand "Andere" toggle ---------------- */
  var brandSelect = root.querySelector('[data-dcc-brand]');
  var brandOtherWrap = root.querySelector('[data-dcc-brand-other]');
  if (brandSelect && brandOtherWrap) {
    brandSelect.addEventListener('change', function () {
      var isOther = brandSelect.value === 'Andere';
      brandOtherWrap.hidden = !isOther;
      if (isOther) brandOtherWrap.querySelector('input').focus();
    });
  }

  /* ---------------- Step 2: treatment cards + packages ---------------- */
  /* Shopify's contact form rejects list-style fields (contact[x][]), so the
     checked treatment checkboxes have no name attribute; instead their
     values are joined into one hidden text field on every change. */
  var treatmentsHiddenField = root.querySelector('[data-dcc-treatments-value]');
  function syncTreatmentsField() {
    if (!treatmentsHiddenField) return;
    var values = Array.prototype.slice.call(root.querySelectorAll('[data-dcc-treatments] input:checked'))
      .map(function (el) { return el.value; });
    treatmentsHiddenField.value = values.join(', ');
  }

  var treatmentCards = root.querySelectorAll('[data-dcc-treatments] .dcc-card');
  treatmentCards.forEach(function (card) {
    var checkbox = card.querySelector('input[type="checkbox"]');
    function sync() { card.classList.toggle('is-selected', checkbox.checked); syncTreatmentsField(); }
    checkbox.addEventListener('change', sync);
    sync();
  });

  root.querySelectorAll('[data-dcc-package]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var includes = (btn.getAttribute('data-dcc-includes') || '').split(',');
      includes.forEach(function (key) {
        var card = root.querySelector('[data-dcc-treatment="' + key + '"]');
        if (!card) return;
        var checkbox = card.querySelector('input[type="checkbox"]');
        checkbox.checked = true;
        card.classList.add('is-selected');
      });
      syncTreatmentsField();
      var err = root.querySelector('[data-dcc-error="treatments"]');
      if (err) err.hidden = true;
      root.querySelectorAll('.dcc-package').forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---------------- Step 3: photo upload (Cloudinary) ---------------- */
  var dropzone = root.querySelector('[data-dcc-dropzone]');
  var fileInput = root.querySelector('[data-dcc-file-input]');
  var photoGrid = root.querySelector('[data-dcc-photo-grid]');
  var photoUrlsField = root.querySelector('[data-dcc-photo-urls]');
  var uploadedUrls = [];
  var photoCount = 0;

  if (dropzone && fileInput) {
    dropzone.addEventListener('click', function () { fileInput.click(); });
    dropzone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
    });
    ['dragenter', 'dragover'].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) { e.preventDefault(); dropzone.classList.remove('is-dragover'); });
    });
    dropzone.addEventListener('drop', function (e) {
      handleFiles(e.dataTransfer.files);
    });
    fileInput.addEventListener('change', function () {
      handleFiles(fileInput.files);
      fileInput.value = '';
    });
  }

  function handleFiles(fileList) {
    Array.prototype.slice.call(fileList).forEach(function (file) {
      if (photoCount >= maxPhotos) return;
      if (!/^image\//.test(file.type) && !/\.heic$/i.test(file.name)) return;
      photoCount++;
      addThumb(file);
    });
  }

  function addThumb(file) {
    var thumb = document.createElement('div');
    thumb.className = 'dcc-photo-thumb';
    var statusEl = document.createElement('div');
    statusEl.className = 'dcc-photo-thumb__status';
    statusEl.textContent = 'Bezig...';
    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'dcc-photo-thumb__remove';
    removeBtn.setAttribute('aria-label', 'Verwijder foto');
    removeBtn.textContent = '×';
    thumb.appendChild(statusEl);
    thumb.appendChild(removeBtn);
    photoGrid.appendChild(thumb);

    var reader = new FileReader();
    reader.onload = function (e) {
      var img = document.createElement('img');
      img.src = e.target.result;
      img.alt = file.name;
      thumb.insertBefore(img, statusEl);
    };
    if (/^image\//.test(file.type)) reader.readAsDataURL(file);

    var assignedUrl = null;

    if (cloudName && uploadPreset) {
      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', uploadPreset);
      fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/upload', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.secure_url) {
            assignedUrl = data.secure_url;
            uploadedUrls.push(assignedUrl);
            updatePhotoUrlsField();
            statusEl.hidden = true;
          } else {
            statusEl.textContent = 'Mislukt';
          }
        })
        .catch(function () { statusEl.textContent = 'Mislukt'; });
    } else {
      statusEl.hidden = true;
    }

    removeBtn.addEventListener('click', function () {
      thumb.remove();
      photoCount--;
      if (assignedUrl) {
        uploadedUrls = uploadedUrls.filter(function (u) { return u !== assignedUrl; });
        updatePhotoUrlsField();
      }
    });
  }

  function updatePhotoUrlsField() {
    if (photoUrlsField) photoUrlsField.value = uploadedUrls.join(', ');
  }

  /* ---------------- Step 5: summary + full message body ---------------- */
  var summaryBox = root.querySelector('[data-dcc-summary]');
  var bodyField = root.querySelector('#dcc-body');

  function val(selector) {
    var el = root.querySelector(selector);
    return el ? el.value.trim() : '';
  }
  function checkedValues(selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector))
      .map(function (el) { return el.value; });
  }
  function radioValue(name) {
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }

  function buildSummary() {
    var brand = brandSelect.value === 'Andere' ? val('#dcc-brand-other') : brandSelect.value;
    var model = val('#dcc-model');
    var year = val('#dcc-year');
    var color = val('#dcc-color');
    var condition = radioValue('contact[Staat van de wagen]');
    var extra = val('#dcc-extra');
    var treatments = checkedValues('[data-dcc-treatments] input:checked');
    var activePackage = root.querySelector('.dcc-package.is-active');
    var packageName = activePackage ? activePackage.getAttribute('data-dcc-package') : '';
    var name = val('#dcc-name');
    var email = val('#dcc-email');
    var phone = val('#dcc-phone');
    var contactPref = radioValue('contact[Contactvoorkeur]');
    var photosCount = uploadedUrls.length;

    var rows = [
      ['Wagen', [brand, model].filter(Boolean).join(' ') || '-'],
      ['Bouwjaar', year || '-'],
      ['Kleur', color || '-'],
      ['Staat', condition || '-'],
      ['Behandelingen', treatments.length ? treatments.join(', ') : '-'],
      ['Pakket', packageName || '-'],
      ['Foto’s', photosCount ? (photosCount + ' geüpload') : 'Geen'],
      ['Naam', name || '-'],
      ['E-mail', email || '-'],
      ['Telefoon', phone || '-'],
      ['Contactvoorkeur', contactPref || '-']
    ];

    summaryBox.innerHTML = rows.map(function (r) {
      return '<div class="dcc-summary__row"><span class="dcc-summary__label">' + r[0] + '</span><span class="dcc-summary__value">' + escapeHtml(r[1]) + '</span></div>';
    }).join('');

    if (bodyField) {
      var lines = [
        'NIEUWE OFFERTEAANVRAAG — DEVINE CAR CUSTOMS', '',
        'Wagen: ' + ([brand, model].filter(Boolean).join(' ') || '-'),
        'Bouwjaar: ' + (year || '-'),
        'Kleur: ' + (color || '-'),
        'Staat van de wagen: ' + (condition || '-'), '',
        'Gewenste behandelingen: ' + (treatments.length ? treatments.join(', ') : '-'),
        'Geselecteerd pakket: ' + (packageName || '-'), '',
        'Extra informatie: ' + (extra || '-'), '',
        'Foto’s (' + photosCount + '): ' + (uploadedUrls.length ? uploadedUrls.join('\n') : '-'), '',
        'Contactvoorkeur: ' + (contactPref || '-')
      ];
      bodyField.value = lines.join('\n');
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Final guard on submit ---------------- */
  form.addEventListener('submit', function (e) {
    for (var i = 1; i <= total; i++) {
      if (!validateStep(i)) {
        e.preventDefault();
        showStep(i);
        return;
      }
    }
    buildSummary();
  });

  showStep(1);
});
})();
